import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { OutcomeBadge } from "@/components/StatusBadge";
import { previewOutcome, Section, YesNo } from "@/components/wizard/controls";

export const StepOutcome = ({ f, set, list }) => {
  const outcome = previewOutcome(f);
  const failing = list.filter((c) => f.competencies[c.key]?.score === 2).map((c) => c.title);
  return (
    <div className="space-y-5" data-testid="step-outcome">
      <section className={`rounded-2xl border-2 p-6 ${outcome === "pass" ? "border-emerald-500/50 bg-emerald-500/5" : "border-red-500/50 bg-red-500/5"}`}>
        <div className="text-xs uppercase tracking-widest text-muted-foreground">Calculated outcome</div>
        <div className="mt-2"><OutcomeBadge outcome={outcome} testId="wizard-outcome-badge" /></div>
        {outcome === "pass" ? (
          <p className="mt-3 text-sm">All competencies at the advanced standard. Next re-assessment will be set for 2 years after the ride date.</p>
        ) : (
          <ul className="mt-3 list-disc space-y-1 pl-5 text-sm">
            {f.unsafe_behaviour && <li>Unsafe or illegal behaviour observed</li>}
            {failing.map((t) => <li key={t}>Not riding to an advanced standard: {t}</li>)}
          </ul>
        )}
      </section>
      {outcome !== "pass" && (
        <Section title="Refer to Trustees?" hint="Use where the rider has not achieved the standard due to concerns over safety or legality. The Trustees and Lead Assessor will decide whether to offer a further assessment.">
          <YesNo value={f.refer_to_trustees} onChange={(v) => set("refer_to_trustees", v)} yes="Refer to Trustees" no="Do not refer" testId="outcome-refer" danger="none" />
          <p className="text-xs text-muted-foreground">Do not offer further training on behalf of SSCBB — direct the rider to IAM RoadSmart or RoSPA.</p>
        </Section>
      )}
      <Section title="Highway Code questions" hint="Only if knowledge appears below standard. Not prepared in advance and based on observations.">
        <YesNo value={f.highway_code_asked} onChange={(v) => set("highway_code_asked", v)} yes="Asked" no="Not needed" testId="outcome-highway" danger="none" />
        {f.highway_code_asked && <Textarea rows={2} placeholder="Questions and responses" value={f.highway_code_notes} onChange={(e) => set("highway_code_notes", e.target.value)} data-testid="outcome-highway-notes" />}
      </Section>
      <Section title="Feedback given to rider" hint="Honest, accurate verbal feedback summary.">
        <Textarea rows={4} value={f.feedback} onChange={(e) => set("feedback", e.target.value)} data-testid="outcome-feedback" />
        <label className="flex items-start gap-3 text-sm">
          <Checkbox checked={f.next_steps_explained} onCheckedChange={(v) => set("next_steps_explained", !!v)} className="mt-0.5 h-5 w-5" data-testid="outcome-next-steps-checkbox" />
          <span>Result confirmed to the rider and next steps explained{outcome !== "pass" ? " (Lead Assessor will contact the rider directly)" : ""}.</span>
        </label>
      </Section>
    </div>
  );
};
